import { slideToggle } from '../../components/utilities';

export default function setDescriptionTabs() {
    const descriptionTabs = document.querySelectorAll('[data-description-tab]');

    if (descriptionTabs.length > 0) descriptionTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tab.classList.toggle('-open');
            const contentWrapper = tab.parentElement.querySelector('.tab-content');
            const content = contentWrapper.querySelector('.text');
            slideToggle(contentWrapper, content)
        })
    })
}